import Ably from "ably";

const client = new Ably.Realtime({
  authUrl: "/api/ably-token"
});


export default client;